import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const DropZone = ({ 
  handleFileSelected,
  icon, 
  fileTypes, 
  maxFileSize, 
  previewImageHeight = 200,
  selectedFileForUpload = null,
}) => {
  const [isDragging, setIsDragging] = useState(false)
  const [previewImageUrl, setPreviewImageUrl] = useState(null)

  useEffect(() => {
    if (!selectedFileForUpload) {
      setPreviewImageUrl(null)
      return
    }

    const url = URL.createObjectURL(selectedFileForUpload)
    setPreviewImageUrl(url)

    return () => URL.revokeObjectURL(url)
  }, [selectedFileForUpload])

  const handleDragLeave = useCallback(() => {
    setIsDragging(false)
  }, [])

  const handleDragOver = useCallback((event) => {
    event.preventDefault()
    setIsDragging(true)
  }, [])

  const handleDrop = useCallback((event) => {
    event.preventDefault()
    setIsDragging(false)
    handleFileChange(event.dataTransfer.files)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      handleFileSelected(files[0]); // Single file for now
    }
  }

  const showPreviewPane = selectedFileForUpload ? true : false

  return (
    <div className={`mt-2 flex justify-center rounded-lg border border-dashed transition 
        ${isDragging ? 'border-indigo-600 bg-indigo-50' : 'border-gray-900/25'}
        ${showPreviewPane ? 'p-2' : 'px-6 py-10'}
      `}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >

      {/* Preview Section */}
      {showPreviewPane && (
        <div>
          <img src={previewImageUrl} alt="Preview" style={{ height: previewImageHeight }} />
        </div>
      )}

      {/* Drop Zone Section */}
      {!showPreviewPane && (
        <div className="flex flex-col items-center text-center">
          {icon}  
          <div className="flex text-gray-600">
            <label htmlFor="file-upload" className="relative font-semibold text-indigo-600 rounded-md cursor-pointer focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500">
              <span>Upload a file</span>
              <input id="file-upload" name="file-upload" type="file" className="sr-only" onChange={(event) => handleFileChange(event.target.files)} />
            </label>
      
            <p className="pl-1">or drag and drop</p>
          </div>
      
          <p className="text-gray-600">{fileTypes.join(", ")} up to {maxFileSize}</p>
        </div>
      )}
    </div>
  )
} 

DropZone.propTypes = {
  fileTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleFileSelected: PropTypes.func.isRequired,
  icon: PropTypes.element.isRequired,
  maxFileSize: PropTypes.string.isRequired,
  previewImageHeight: PropTypes.number,
  selectedFileForUpload: PropTypes.object,
}

export { DropZone }